import IconElsa from 'assets/img/icon-elsa.svg';
// import IconCourse from 'assets/img/icon-course.svg';
// import IconBill from 'assets/img/icon-bill.svg';
import IconRedeem from 'assets/img/icon-redeem.svg';
import IconLogout from 'assets/img/icon-logout.svg';
import IconUpgrade from 'assets/img/icon-upgrade.svg';
import React, { useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Link, useLocation} from 'react-router-dom';
import { Menu } from 'antd';
import UserImageProfile from 'components/user/UserImageProfile';
import GlobalStore from 'stores/globalStore';
import { removeItem } from 'utils/local-storage';
import { URL_QUERY_STRING } from 'utils/storage-keys';
import { useTranslation } from 'react-i18next';

const Sidebar: React.FC = () => {
  const { t } = useTranslation();
  const { signOut, isNavOpened, toggleNav, entitlements } = GlobalStore.useContainer();
  const [selectedMenuItem, setSelectedMenuItem] =
    React.useState<string>('profile');
  const { SubMenu } = Menu;
  const location = useLocation().pathname;
  
  const locationActive = location.slice(location.lastIndexOf('/') + 1);
  
  const handleMenuClick = (e: any) => {
    if (e.key === 'SignOut') {
      signOut();
      removeItem(URL_QUERY_STRING);
    }
    setSelectedMenuItem(e.key);
    toggleNav();
  };
  useEffect(() => {
    setSelectedMenuItem(locationActive);
  }, [locationActive]);

  return (
    <aside className={'site-layout__sidebar' + (isNavOpened ? ' is-open' : '')}>
      <div className="text-center visible-desktop">
        <UserImageProfile />
      </div>
      <Menu
        theme="dark"
        selectedKeys={[selectedMenuItem]}
        mode="inline"
        onClick={(e) => handleMenuClick(e)}
      >
        <SubMenu
          key="sub1"
          icon={<UserOutlined />}
          title={t('profile.account_info')}
          className='submenu'
        >
          <Menu.Item key="profile">
            <Link to={`/${t('slug.user')}`}>{t('profile.account_info')}</Link>
          </Menu.Item>
          <Menu.Item key="change-profile">
            <Link to={`/${t('slug.update_profile')}`}>{t('profile.update_profile')}</Link>
          </Menu.Item>
          <Menu.Item key="change-password">
            <Link to={`/${t('slug.change_password')}`}>{t('profile.update_password')}</Link>
          </Menu.Item>
        </SubMenu>
        <Menu.Item key="score">
          <img src={IconElsa} alt="Điểm ELSA" />
          <Link to={`/${t('slug.score')}`}>{t('score.page_title')}</Link>
        </Menu.Item>
        {entitlements && entitlements.tier.code !== 'professional' && (
          <SubMenu
            icon={<img src={IconUpgrade} alt={t('upgrade')} />}
            title={t('upgrade')}
          >
            {entitlements?.tier?.code !== 'premium' && (
              <Menu.Item key="upgrade-premium">
                <Link to={`/elsa-premium`}>ELSA Premium</Link>
              </Menu.Item>
            )}
            <Menu.Item key="upgrade-professional">
              <Link to={`/elsa-professional`}>ELSA Professional</Link>
            </Menu.Item>
            {entitlements?.tier?.code === 'free' && (
              <Menu.Item key="upgrade-pro">
                <Link to={`/elsa-pro`}>ELSA Pro</Link>
              </Menu.Item>
            )}
          </SubMenu>
        )}
        <Menu.Item key="redeem-voucher">
          <img src={IconRedeem} alt={t('redeem.page_title')} />
          <Link to={`/${t('slug.redeem')}`}>{t('redeem.page_title')}</Link>
        </Menu.Item>
        <Menu.Item key="SignOut" className="hidden-desktop">
          <img src={IconLogout} alt="Logout" />
          {t('logout')}
        </Menu.Item>
      </Menu>
    </aside>
  );
};

export default Sidebar;

